export default [
  '/',
  '/home',
  '/login',
  '/register'
]
